export default "__VITE_ASSET__9a95bccc__"